import type {RouteLocationNormalizedLoaded} from 'vue-router'

export async function useTransferRuntimeData(route: RouteLocationNormalizedLoaded) {
    const searchRequest = transfersRuntimeStore.searchRequestFromQuery(route.query)
    const {
        arrivalHotelCode,
        arrivalPlace,
        arrivalCityId,
        arrivalPlaceId,
        departureHotelCode,
        departurePlace,
        departureCityId,
        departurePlaceId,
    } = searchRequest
    const promises = []
    if (
        (arrivalHotelCode && arrivalHotelCode !== transfersRuntimeStore.arrivalPoint.hotelCode) ||
        (!arrivalHotelCode && arrivalPlace === 'hotel' && arrivalCityId !== transfersRuntimeStore.arrivalPoint.id) ||
        (!arrivalHotelCode &&
            !['hotel', 'position'].includes(arrivalPlace) &&
            isNaN(arrivalPlace) &&
            arrivalPlace !== transfersRuntimeStore.arrivalPoint.iataCode) ||
        (!arrivalHotelCode && !isNaN(arrivalPlace) && arrivalPlace !== transfersRuntimeStore.arrivalPoint.id) ||
        (arrivalPlace === 'position' && arrivalPlaceId !== transfersRuntimeStore.arrivalPoint.placeId)
    ) {
        promises.push(transfersRuntimeStore.loadArrivalPoint(searchRequest))
    }
    if (
        (departureHotelCode && departureHotelCode !== transfersRuntimeStore.departurePoint.hotelCode) ||
        (!departureHotelCode &&
            departurePlace === 'hotel' &&
            departureCityId !== transfersRuntimeStore.departurePoint.id) ||
        (!departureHotelCode &&
            !['hotel', 'position'].includes(departurePlace) &&
            isNaN(departurePlace) &&
            departurePlace !== transfersRuntimeStore.departurePoint.iataCode) ||
        (!departureHotelCode && !isNaN(departurePlace) && departurePlace !== transfersRuntimeStore.departurePoint.id) ||
        (departurePlace === 'position' && departurePlaceId !== transfersRuntimeStore.arrivalPoint.placeId)
    ) {
        promises.push(transfersRuntimeStore.loadDeparturePoint(searchRequest))
    }
    await Promise.all(promises)
}
